import SubcategoryPage from '@/components/template/SubcategoryPage';

const ResinaUmivalniki = () => {
  const products = [
    {
      title: "Resina Umivalnik Moder",
      imageSrc: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80",
      url: "/umivalniki/resina/moder"
    },
    {
      title: "Resina Umivalnik Marmor Efekt",
      imageSrc: "https://images.unsplash.com/photo-1600566752610-111d521cf1de?auto=format&fit=crop&q=80",
      url: "/umivalniki/resina/marmor-efekt"
    },
    {
      title: "Resina Umivalnik Terrazzo",
      imageSrc: "https://images.unsplash.com/photo-1602028915047-37269d1a73f7?auto=format&fit=crop&q=80",
      url: "/umivalniki/resina/terrazzo"
    },
    {
      title: "Resina Umivalnik Gradient",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/umivalniki/resina/gradient"
    },
    {
      title: "Resina Umivalnik Premium",
      imageSrc: "https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&q=80",
      url: "/umivalniki/resina/premium"
    },
    {
      title: "Resina Umivalnik Modern",
      imageSrc: "https://images.unsplash.com/photo-1600566752427-25ef8fb4e018?auto=format&fit=crop&q=80",
      url: "/umivalniki/resina/modern"
    }
  ];

  return (
    <SubcategoryPage
      title="Resina Umivalniki"
      description="Doživite eleganco naših umivalnikov iz resine, ki se ponaša z gladko površino in vsestranskimi oblikami. Resina umivalniki združujejo trajnost z možnostjo številnih barv, vzorcev in oblik za edinstven izgled vaše kopalnice."
      heroImage="https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default ResinaUmivalniki;